import { useState } from 'react';
import { Typography, Link } from '@optimus-web/core';
import { ReservationDetailPanel } from '../panels/ReservationDetailPanel';
import { ResourceName } from '../../../../components/reservation/ResourceName';
import { ProductCheckListDataRow } from '../../types';
import { ProductCheckListDataTestIds } from '../../constants';

interface ResourceCellProps {
    row: ProductCheckListDataRow;
    active?: boolean;
}

export const ResourceCell: React.FC<ResourceCellProps> = ({ row, active = true }) => {
    const { reservation, resourceId } = row;
    const [reservationOpened, setReservationOpened] = useState(false);

    return (
        <span data-test-id={ProductCheckListDataTestIds.cellResource} data-test-resource-id={row.resourceId}>
            <Typography textStyle="bodyMediumStrong" variant={!active ? 'tertiary' : 'primary'} as="div">
                {reservation && active ? (
                    <Link
                        inherit
                        onClick={() => setReservationOpened(true)}
                        disabled={!(reservation && active)}
                        data-test-view-smart-detail
                    >
                        <ResourceName resourceId={resourceId} notFoundElement={null} />
                    </Link>
                ) : (
                    <ResourceName resourceId={resourceId} notFoundElement={null} />
                )}
            </Typography>
            {reservation && (
                <ReservationDetailPanel
                    opened={reservationOpened}
                    onClose={() => setReservationOpened(false)}
                    reservation={reservation}
                />
            )}
        </span>
    );
};
